/* src/app/common/components/menu-items/menu-items.component.scss */
.toolbar-container ion-toolbar {
  --background: transparent;
  --min-height: auto;
}
.toolbar-container ion-toolbar ion-title {
  padding: 0;
  font-size: 28px;
  font-weight: 500;
}
.toolbar-container ion-toolbar .actions {
  margin-right: -0.5rem;
}
.toolbar-container ion-toolbar .actions > ion-button,
.toolbar-container ion-toolbar .actions > app-button-group {
  margin: 0 0.5rem;
}
:host {
  display: block;
}
section.items-container.row {
  --bs-gutter-x: 0;
  --bs-gutter-y: 0;
  padding: 0.5rem;
}
section.items-container.row > .col {
  padding: 1rem;
}
ion-card {
  margin: 0;
  border-radius: var(--card-border-radius, 0);
  box-shadow: none;
  border: 1px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.1s ease-in-out 0.25s;
  min-width: 200px;
}
ion-card:focus-within,
ion-card:hover {
  border-color: rgba(0, 0, 0, 0.13);
}
ion-card:focus-within ion-card-header .actions,
ion-card:hover ion-card-header .actions {
  opacity: 1;
}
ion-card .thumbnail {
  height: 100px;
  max-height: 100px;
  overflow: hidden;
  background-image: url(https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg);
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  background-size: cover;
  position: relative;
}
ion-card .thumbnail app-food-type-indicator {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
}
ion-card ion-card-header {
  padding: 0;
}
ion-card ion-card-header .title-container {
  margin-bottom: -18px;
}
ion-card ion-card-header ion-card-title {
  text-align: left;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
ion-card ion-card-header ion-card-subtitle {
  margin-top: 4px;
}
ion-card ion-card-header ion-card-subtitle > * {
  display: inline-block;
  vertical-align: middle;
  padding: 0 2px;
}
ion-card ion-card-header ion-card-subtitle ion-icon {
  vertical-align: middle;
}
ion-card ion-card-header ion-card-subtitle.tags ion-icon {
  vertical-align: text-bottom;
}
ion-card ion-card-header section.actions {
  position: absolute;
  top: -8px;
  right: 0;
  opacity: 0;
}
ion-card ion-card-header section.actions ion-button {
  margin: 0;
}
ion-card ion-card-header section.actions ion-button ion-icon {
  font-size: 20px;
}
ion-card ion-card-content {
  padding: 0;
  padding-top: 0.25rem;
}
ion-card ion-card-content > * {
  padding: 0.25rem 0;
}
ion-card ion-card-content .dashboard {
  border: 1px solid red;
}
ion-card ion-card-content .description {
  text-align: justify;
  padding: 5px 10px;
}
ion-card .bold-text {
  font-weight: bold;
}
ion-card .quantity-info {
  display: flex;
  justify-content: space-between;
}
/*# sourceMappingURL=menu-items.component.css.map */
